import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";

import Products from "@/modules/Products";
let products = new Products();
products.loadProducts();

import router from "./routes";
import store from "./state";

window.app = createApp(App).use(router).use(store).mount("#app");
